import { loadableWithFallback } from '@vision/ui/utils';
import type { WordCloudChart1Props } from './WordCloudChart1';

export const WordCloudChart1 = loadableWithFallback<WordCloudChart1Props>(() => import('./WordCloudChart1'));
